import { all, fork, takeLatest } from "redux-saga/effects";

import { LOGIN_REQUEST, LOGOUT } from "../../actions/authActions";
import { loginSaga, logoutSaga } from "../../sagas/authSaga";
import watchEmploiSagas from "../../sagas/emploiSagas";

import {
  GET_NOTIFICATION_SETTINGS_REQUEST,
  CREATE_NOTIFICATION_SETTING_REQUEST,
  UPDATE_NOTIFICATION_SETTING_REQUEST,
  DELETE_NOTIFICATION_SETTING_REQUEST,
} from "../../actions/notificationSettingsActions";
import {
  getNotificationSettingsSaga,
  createNotificationSettingSaga,
  updateNotificationSettingSaga,
  deleteNotificationSettingSaga,
} from "../notificationSettingsSaga";

import watchNotificationSagas from "../../sagas/notificationSaga";

import {
  GET_USER_REQUEST,
  GET_ALL_USERS_REQUEST,
  GET_USERS_BY_STATUS_REQUEST,
  GET_USERS_BY_JOB_REQUEST,
  GET_USERS_BY_ENTITY_REQUEST,
  CREATE_USER_REQUEST,
  UPDATE_USER_REQUEST,
  UPDATE_USER_ACCOUNT_STATUS_REQUEST,
  DELETE_USER_REQUEST,
  ASSIGN_ROLES_REQUEST,
  REMOVE_ROLES_REQUEST,
  MASS_IMPORT_USERS_REQUEST,
  DOWNLOAD_USERS_TEMPLATE_REQUEST,
  EXPORT_USERS_REQUEST,
  REVIEW_USERS_MASS_IMPORT_REQUEST,
  IMPORT_USERS_MASS_REQUEST,
  GET_TROMBINOSCOPE_REQUEST,
  GET_USER_JOB_HISTORY_REQUEST,
  GET_DIRECT_REPORTS_REQUEST,
  UPDATE_MY_PROFILE_REQUEST,
  UPLOAD_USER_PHOTO_REQUEST,
  UPLOAD_ATTESTATION_RIB_REQUEST,
} from "../../actions/userActions";
import {
  getUserSaga,
  getAllUsersSaga,
  getUsersByStatusSaga,
  getUsersByJobSaga,
  getUsersByEntitySaga,
  createUserSaga,
  updateUserSaga,
  updateUserAccountStatusSaga,
  deleteUserSaga,
  assignRolesSaga,
  removeRolesSaga,
  massImportUsersSaga,
  downloadUsersTemplateSaga,
  exportUsersSaga,
  reviewUsersMassImportSaga,
  importUsersMassSaga,
  getTrombinoscopeSaga,
  getUserJobHistorySaga,
  getDirectReportsSaga,
  uploadUserPhotoSaga,
  uploadAttestationRibSaga,
  updateMyProfileSaga,
} from "../../sagas/userSagas";

import {
  CREATE_JOB_REQUEST,
  DELETE_JOB_REQUEST,
  DOWNLOAD_JOBS_TEMPLATE_REQUEST,
  EXPORT_JOBS_REQUEST,
  GET_ALL_JOBS_REQUEST,
  IMPORT_JOBS_EXCEL_REQUEST,
  UPDATE_JOB_REQUEST,
} from "../../actions/Jobactions";
import {
  createJobSaga,
  deleteJobSaga,
  downloadJobsTemplateSaga,
  exportJobsExcelSaga,
  getAllJobsSaga,
  importJobsExcelSaga,
  updateJobSaga,
} from "../../sagas/jobSaga";

import {
  CREATE_ENTITE_REQUEST,
  DELETE_ENTITE_REQUEST,
  GET_ALL_ENTITES_REQUEST,
  GET_ORGANIGRAMME_REQUEST,
  UPDATE_ENTITE_REQUEST,
} from "../../actions/entitesActions";
import {
  createEntiteSaga,
  deleteEntiteSaga,
  getAllEntitesSaga,
  getOrgSaga,
  updateEntiteSaga,
} from "../../sagas/entitesSaga";

import {
  GET_SIDEBAR_MENU_REQUEST,
  GET_ALL_SIDEBAR_MENUS_REQUEST,
  GET_ORDERED_SIDEBAR_MENUS_REQUEST,
  GET_SIDEBAR_MENUS_BY_ROLE_REQUEST,
  GET_SIDEBAR_MENUS_BY_STATUS_REQUEST,
  GET_ROOT_SIDEBAR_MENUS_REQUEST,
  GET_CHILD_SIDEBAR_MENUS_REQUEST,
  CREATE_SIDEBAR_MENU_REQUEST,
  UPDATE_SIDEBAR_MENU_REQUEST,
  DELETE_SIDEBAR_MENU_REQUEST,
  GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_REQUEST,
} from "../../actions/sidebarMenuActions";
import {
  getSidebarMenuSaga,
  getAllSidebarMenusSaga,
  getOrderedSidebarMenusSaga,
  getSidebarMenusByRoleSaga,
  getSidebarMenusByStatusSaga,
  getRootSidebarMenusSaga,
  getChildSidebarMenusSaga,
  createSidebarMenuSaga,
  updateSidebarMenuSaga,
  deleteSidebarMenuSaga,
  getSidebarMenusByRoleAdminSaga,
} from "../../sagas/sidebarMenuSagas";

import {
  GET_COMPANY_REQUEST,
  GET_COMPANY_BY_CODE_REQUEST,
  GET_ALL_COMPANIES_REQUEST,
  CREATE_COMPANY_REQUEST,
  UPDATE_COMPANY_REQUEST,
  DELETE_COMPANY_REQUEST,
  GET_HOLIDAYS_REQUEST,
} from "../../actions/companyactions";
import {
  getCompanySaga,
  getCompanyByCodeSaga,
  getAllCompaniesSaga,
  createCompanySaga,
  updateCompanySaga,
  deleteCompanySaga,
  getHolidaysSaga,
} from "../../sagas/companySaga";

import {
  GET_ROLE_REQUEST,
  GET_ALL_ROLES_REQUEST,
  GET_ACTIVE_ROLES_REQUEST,
  GET_ROLES_BY_MODULE_REQUEST,
  GET_GLOBAL_ROLES_REQUEST,
  CREATE_ROLE_REQUEST,
  UPDATE_ROLE_REQUEST,
  DELETE_ROLE_REQUEST,
} from "../../actions/roleActions";
import {
  getRoleSaga,
  getAllRolesSaga,
  getActiveRolesSaga,
  getRolesByModuleSaga,
  getGlobalRolesSaga,
  createRoleSaga,
  updateRoleSaga,
  deleteRoleSaga,
} from "../../sagas/roleSagas";

import {
  GET_ALL_EMAIL_TEMPLATES_REQUEST,
  GET_EMAIL_TEMPLATE_REQUEST,
  CREATE_EMAIL_TEMPLATE_REQUEST,
  UPDATE_EMAIL_TEMPLATE_REQUEST,
  DELETE_EMAIL_TEMPLATE_REQUEST,
  GET_EMAIL_PLACEHOLDERS_REQUEST,
  PREVIEW_EMAIL_TEMPLATE_REQUEST,
  SEND_ACCOUNT_ACTIVATION_REQUEST,
  GET_EMAIL_LOGS_REQUEST,
  REQUEST_PASSWORD_RESET_REQUEST,
  CONFIRM_PASSWORD_RESET_REQUEST,
} from "../../actions/emailActions";
import {
  getAllEmailTemplatesSaga,
  getEmailTemplateSaga,
  createEmailTemplateSaga,
  updateEmailTemplateSaga,
  deleteEmailTemplateSaga,
  getEmailPlaceholdersSaga,
  previewEmailTemplateSaga,
  sendAccountActivationSaga,
  getEmailLogsSaga,
  requestPasswordResetSaga,
  confirmPasswordResetSaga,
} from "../../sagas/emailSaga";

import { watchTaskSettings } from "../../sagas/taskSettingsSaga";

import {
  GET_APPLICATION_LOGS_REQUEST,
  GET_APPLICATION_LOG_REQUEST,
  GET_APPLICATION_LOGS_BY_MODULE_REQUEST,
  GET_APPLICATION_LOGS_BY_USER_REQUEST,
} from "../../actions/applicationLogActions";
import {
  getApplicationLogsSaga,
  getApplicationLogSaga,
  getApplicationLogsByModuleSaga,
  getApplicationLogsByUserSaga,
} from "../../sagas/applicationLogSagas";

import kpiSagas from "../../sagas/kpiSaga";
import reportSagas from "../../sagas/reportSaga";

export default function* administrationRootSaga() {
  yield all([
    takeLatest(GET_NOTIFICATION_SETTINGS_REQUEST, getNotificationSettingsSaga),
    takeLatest(CREATE_NOTIFICATION_SETTING_REQUEST, createNotificationSettingSaga),
    takeLatest(UPDATE_NOTIFICATION_SETTING_REQUEST, updateNotificationSettingSaga),
    takeLatest(DELETE_NOTIFICATION_SETTING_REQUEST, deleteNotificationSettingSaga),
    fork(watchNotificationSagas),
    fork(watchEmploiSagas),

    takeLatest(LOGIN_REQUEST, loginSaga),
    takeLatest(LOGOUT, logoutSaga),

    takeLatest(GET_USER_REQUEST, getUserSaga),
    takeLatest(GET_ALL_USERS_REQUEST, getAllUsersSaga),
    takeLatest(UPDATE_MY_PROFILE_REQUEST, updateMyProfileSaga),
    takeLatest(UPLOAD_USER_PHOTO_REQUEST, uploadUserPhotoSaga),
    takeLatest(UPLOAD_ATTESTATION_RIB_REQUEST, uploadAttestationRibSaga),
    takeLatest(GET_USERS_BY_STATUS_REQUEST, getUsersByStatusSaga),
    takeLatest(GET_USERS_BY_JOB_REQUEST, getUsersByJobSaga),
    takeLatest(GET_USERS_BY_ENTITY_REQUEST, getUsersByEntitySaga),
    takeLatest(CREATE_USER_REQUEST, createUserSaga),
    takeLatest(UPDATE_USER_REQUEST, updateUserSaga),
    takeLatest(UPDATE_USER_ACCOUNT_STATUS_REQUEST, updateUserAccountStatusSaga),
    takeLatest(DELETE_USER_REQUEST, deleteUserSaga),
    takeLatest(ASSIGN_ROLES_REQUEST, assignRolesSaga),
    takeLatest(REMOVE_ROLES_REQUEST, removeRolesSaga),
    takeLatest(MASS_IMPORT_USERS_REQUEST, massImportUsersSaga),
    takeLatest(DOWNLOAD_USERS_TEMPLATE_REQUEST, downloadUsersTemplateSaga),
    takeLatest(EXPORT_USERS_REQUEST, exportUsersSaga),
    takeLatest(REVIEW_USERS_MASS_IMPORT_REQUEST, reviewUsersMassImportSaga),
    takeLatest(IMPORT_USERS_MASS_REQUEST, importUsersMassSaga),
    takeLatest(GET_TROMBINOSCOPE_REQUEST, getTrombinoscopeSaga),
    takeLatest(GET_USER_JOB_HISTORY_REQUEST, getUserJobHistorySaga),
    takeLatest(GET_DIRECT_REPORTS_REQUEST, getDirectReportsSaga),

    takeLatest(GET_ALL_JOBS_REQUEST, getAllJobsSaga),
    takeLatest(CREATE_JOB_REQUEST, createJobSaga),
    takeLatest(UPDATE_JOB_REQUEST, updateJobSaga),
    takeLatest(DELETE_JOB_REQUEST, deleteJobSaga),
    takeLatest(IMPORT_JOBS_EXCEL_REQUEST, importJobsExcelSaga),
    takeLatest(EXPORT_JOBS_REQUEST, exportJobsExcelSaga),
    takeLatest(DOWNLOAD_JOBS_TEMPLATE_REQUEST, downloadJobsTemplateSaga),

    takeLatest(GET_ALL_ENTITES_REQUEST, getAllEntitesSaga),
    takeLatest(CREATE_ENTITE_REQUEST, createEntiteSaga),
    takeLatest(UPDATE_ENTITE_REQUEST, updateEntiteSaga),
    takeLatest(DELETE_ENTITE_REQUEST, deleteEntiteSaga),
    takeLatest(GET_ORGANIGRAMME_REQUEST, getOrgSaga),

    takeLatest(GET_SIDEBAR_MENU_REQUEST, getSidebarMenuSaga),
    takeLatest(GET_ALL_SIDEBAR_MENUS_REQUEST, getAllSidebarMenusSaga),
    takeLatest(GET_ORDERED_SIDEBAR_MENUS_REQUEST, getOrderedSidebarMenusSaga),
    takeLatest(GET_SIDEBAR_MENUS_BY_ROLE_REQUEST, getSidebarMenusByRoleSaga),
    takeLatest(GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_REQUEST, getSidebarMenusByRoleAdminSaga),
    takeLatest(GET_SIDEBAR_MENUS_BY_STATUS_REQUEST, getSidebarMenusByStatusSaga),
    takeLatest(GET_ROOT_SIDEBAR_MENUS_REQUEST, getRootSidebarMenusSaga),
    takeLatest(GET_CHILD_SIDEBAR_MENUS_REQUEST, getChildSidebarMenusSaga),
    takeLatest(CREATE_SIDEBAR_MENU_REQUEST, createSidebarMenuSaga),
    takeLatest(UPDATE_SIDEBAR_MENU_REQUEST, updateSidebarMenuSaga),
    takeLatest(DELETE_SIDEBAR_MENU_REQUEST, deleteSidebarMenuSaga),

    takeLatest(GET_COMPANY_REQUEST, getCompanySaga),
    takeLatest(GET_COMPANY_BY_CODE_REQUEST, getCompanyByCodeSaga),
    takeLatest(GET_ALL_COMPANIES_REQUEST, getAllCompaniesSaga),
    takeLatest(CREATE_COMPANY_REQUEST, createCompanySaga),
    takeLatest(UPDATE_COMPANY_REQUEST, updateCompanySaga),
    takeLatest(DELETE_COMPANY_REQUEST, deleteCompanySaga),
    takeLatest(GET_HOLIDAYS_REQUEST, getHolidaysSaga),

    takeLatest(GET_ROLE_REQUEST, getRoleSaga),
    takeLatest(GET_ALL_ROLES_REQUEST, getAllRolesSaga),
    takeLatest(GET_ACTIVE_ROLES_REQUEST, getActiveRolesSaga),
    takeLatest(GET_ROLES_BY_MODULE_REQUEST, getRolesByModuleSaga),
    takeLatest(GET_GLOBAL_ROLES_REQUEST, getGlobalRolesSaga),
    takeLatest(CREATE_ROLE_REQUEST, createRoleSaga),
    takeLatest(UPDATE_ROLE_REQUEST, updateRoleSaga),
    takeLatest(DELETE_ROLE_REQUEST, deleteRoleSaga),

    takeLatest(GET_ALL_EMAIL_TEMPLATES_REQUEST, getAllEmailTemplatesSaga),
    takeLatest(GET_EMAIL_TEMPLATE_REQUEST, getEmailTemplateSaga),
    takeLatest(CREATE_EMAIL_TEMPLATE_REQUEST, createEmailTemplateSaga),
    takeLatest(UPDATE_EMAIL_TEMPLATE_REQUEST, updateEmailTemplateSaga),
    takeLatest(DELETE_EMAIL_TEMPLATE_REQUEST, deleteEmailTemplateSaga),
    takeLatest(GET_EMAIL_PLACEHOLDERS_REQUEST, getEmailPlaceholdersSaga),
    takeLatest(PREVIEW_EMAIL_TEMPLATE_REQUEST, previewEmailTemplateSaga),
    takeLatest(SEND_ACCOUNT_ACTIVATION_REQUEST, sendAccountActivationSaga),
    takeLatest(GET_EMAIL_LOGS_REQUEST, getEmailLogsSaga),
    takeLatest(REQUEST_PASSWORD_RESET_REQUEST, requestPasswordResetSaga),
    takeLatest(CONFIRM_PASSWORD_RESET_REQUEST, confirmPasswordResetSaga),

    fork(watchTaskSettings),
    takeLatest(GET_APPLICATION_LOGS_REQUEST, getApplicationLogsSaga),
    takeLatest(GET_APPLICATION_LOG_REQUEST, getApplicationLogSaga),
    takeLatest(GET_APPLICATION_LOGS_BY_MODULE_REQUEST, getApplicationLogsByModuleSaga),
    takeLatest(GET_APPLICATION_LOGS_BY_USER_REQUEST, getApplicationLogsByUserSaga),
  ]);

  yield all([
    fork(kpiSagas),
    fork(reportSagas),
  ]);
}
